import { v4 } from "uuid";

import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { initDraft } from "@src/store/slices/experienceBuilder/basicMod/thunks/initDraft";
import { getVariationMods } from "@src/store/slices/experienceBuilder/common/selectors/getVariationMods";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";

export const selectInjection = createAsyncThunk<void, void>(
  "experienceBuilder/selectElement",
  (_, { dispatch, getState }) => {
    const mods = getVariationMods(getState());
    const injectionMod = mods.find(
      (m) => m.category === "basicMod" && m.type === "injection"
    );

    if (injectionMod) {
      void dispatch(initDraft(injectionMod));
    } else {
      const variationId =
        experienceBuilderSlice.selectors.getVariationId(getState());
      void dispatch(
        initDraft({
          type: "injection",
          category: "basicMod",
          id: v4(),
          variationId,
          js: "",
          css: "",
          tab: "css",
          jsInjectionMode: {
            type: "immediately",
            timeout: 0,
          },
        })
      );
    }
  }
);
